@if (item.nestedItems?.length > 0) {
  <glxy-nav-item-list
    [icon]="item.icon"
    [isSvg]="item.svgIcon"
    [id]="item.menuId"
    [startExpanded]="shouldExpandMenu"
    (clicked)="onClick($event)"
    [attr.data-action]="'PartnerCenter:Nav:toggled-' + item.menuId"
  >
    {{ navTitle }}
    <glxy-nav-item-list-items>
      <app-nav-item
        *ngFor="let nesteditem of item.nestedItems"
        [activeMenuId]="activeMenuId"
        [item]="nesteditem"
      ></app-nav-item>
    </glxy-nav-item-list-items>
  </glxy-nav-item-list>
} @else {
  @if (item.subsectionHeader) {
    <glxy-nav-subheader>
      {{ item.subsectionHeader | translate }}
    </glxy-nav-subheader>
  }
  @if (linkIsHandledInComponent) {
    <glxy-nav-item
      [ngClass]="{
        active: item.menuId === activeMenuId,
      }"
      [activeExactRoute]="true"
      [id]="item.menuId"
      (click)="navTabClicked(item)"
      [icon]="item.icon"
      [isSvg]="item.svgIcon"
      [attr.data-action]="'PartnerCenter:Nav:clicked-' + item.menuId"
    >
      {{ navTitle }}
      <glxy-nav-item-accessory *ngTemplateOutlet="navIcon"></glxy-nav-item-accessory>
    </glxy-nav-item>
  } @else {
    <glxy-nav-item
      [ngClass]="{ active: item.menuId === activeMenuId }"
      [id]="item.menuId"
      [route]="item.ngRoute ? item.url : ''"
      [href]="!item.ngRoute ? item.url : ''"
      [target]="item.popOut ? '_blank' : '_self'"
      [icon]="item.icon"
      [isSvg]="item.svgIcon"
      [attr.data-action]="'PartnerCenter:Nav:clicked-' + item.menuId"
      [activeExactRoute]="true"
    >
      {{ navTitle }}
      <glxy-nav-item-accessory *ngTemplateOutlet="navIcon"></glxy-nav-item-accessory>
    </glxy-nav-item>
  }
}

<!-- Sets the contextual icon for a nav item -->
<ng-template #navIcon>
  @switch (navType) {
    @case (navLinkTypes.DISABLED) {
      <mat-icon
        class="open-new-icon right-icon disabled"
        [glxyTooltip]="tooltip | translate"
        [tooltipPositions]="positions"
      >
        error_outline
      </mat-icon>
    }
    @case (navLinkTypes.LOCKED) {
      <mat-icon class="other-icon right-icon">arrow_circle_up</mat-icon>
    }
    @case (navLinkTypes.POPOUT) {
      <mat-icon class="open-new-icon right-icon">open_in_new</mat-icon>
    }
    @case (navLinkTypes.SUBNAV) {
      <i [className]="item.rightIcon">chevron_right</i>
    }
    @case (navLinkTypes.BETA) {
      <glxy-badge [size]="'small'" [color]="'blue-solid'">
        {{ 'COMMON.BETA' | translate }}
      </glxy-badge>
    }
    @case (navLinkTypes.NEW) {
      <glxy-badge [size]="'small'" [color]="'green-solid'">
        {{ 'COMMON.NEW' | translate }}
      </glxy-badge>
    }
  }
</ng-template>
